import { CommonModule } from '@angular/common';
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Input,
  input,
  Output,
  output,
} from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CheckboxModule } from 'primeng/checkbox';
import { InputTextModule } from 'primeng/inputtext';
import { FilterOnNamePipe } from './filterOnName.pipe';
import {
  FiltersRegion,
  FiltersLocation,
} from '../../../interfaces/region.interface';

@Component({
  selector: 'z-list-filter',
  standalone: true,
  imports: [
    CommonModule,
    CheckboxModule,
    FormsModule,
    InputTextModule,
    FilterOnNamePipe,
  ],
  templateUrl: './list-filter.component.html',
  styleUrls: ['./list-filter.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListFilterComponent {
  regions = input.required<FiltersRegion[]>();
  locations = input.required<FiltersLocation[]>();
  selectedFilterType = input.required<'region' | 'location'>();

  onRegionsChange = output<FiltersRegion[]>();
  onLocationsChange = output<FiltersLocation[]>();

  @Input() selectedRegions: FiltersRegion[] = [];
  @Output() selectedRegionsChange = new EventEmitter<string>();

  @Input() selectedLocations: FiltersLocation[] = [];
  @Output() selectedLocationsChange = new EventEmitter<string>();

  constructor(readonly cd: ChangeDetectorRef) {}

  onChange() {
    if (this.selectedFilterType() === 'region') {
      this.onRegionsChange.emit(this.selectedRegions);
    } else {
      this.onLocationsChange.emit(this.selectedLocations);
    }
  }

  regionsChange(ev: string) {
    this.selectedRegionsChange.emit(ev);
    this.cd.detectChanges();
  }

  locationsChange(ev: string) {
    this.selectedLocationsChange.emit(ev);
    this.cd.detectChanges();
  }
}
